<template>
  <div class="text-center">
    <v-dialog
      :fullscreen="$vuetify.breakpoint.smAndDown || step === 'send'"
      max-width="1000"
      v-model="dialog"
      scrollable
      :persistent="creating"
    >
      <v-card>
        <v-card-title class="primary white--text">
          Thêm Điểm môn học {{ $_get(filterParams, 'subject.title') }} theo tệp Excel <v-spacer></v-spacer>
          <v-btn dark icon>
            <v-icon :disabled="creating" @click="cancel">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div
            class="d-flex flex-column justify-center align-center mx-auto"
            style="width: 400px; min-height: 320px"
            v-if="step === 'import'"
          >
            <v-img max-width="100px" max-height="100px" contain src="../../assets/upload-file.svg"></v-img>
            <div class="text-center content-text mt-5">
              Tải lên tệp Excel (.xlsx) chứa điểm của học sinh
            </div>
            <div class="mt-5">
              <v-btn color="primary" class="elevation-0" :loading="isSelecting" @click="onExcelUpload">
                <span>Chọn tệp</span>
                <input
                  ref="uploader"
                  type="file"
                  class="d-none"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  @change="onFileChanged"
                />
              </v-btn>
            </div>
          </div>
          <div class="pa-5" style="height: 100%" v-else-if="step === 'send'">
            <div v-if="creating">
              <div class="mb-2">
                <v-progress-circular indeterminate color="primary" class="mr-4"></v-progress-circular>
                <span>
                  Đang tạo điểm học sinh...
                </span>
              </div>
              <v-progress-linear v-model="progress" color="success" height="25" rounded>
                <strong>{{ Math.ceil(progress) }}%</strong>
              </v-progress-linear>
            </div>
            <div class="d-flex align-center" v-else>
              <v-text-field
                v-model="selectedFile.name"
                outlined
                prepend-inner-icon="mdi-file"
                disabled
                hide-details
              ></v-text-field>
              <v-btn color="primary" @click="cancelChooseFile" text>Chọn tệp khác</v-btn>
            </div>

            <div v-if="excelErrorStudents.length">
              <div class="text-h6 mt-4 error--text">Lỗi dữ liệu</div>
              <div>
                Đã có {{ excelErrorStudents.length }} học sinh trong tệp excel gặp lỗi. Vui lòng kiểm tra lại dữ liệu và
                ấn
                <span>
                  <b> [Chọn tệp khác] </b>
                </span>
                để upload file excel mới.
              </div>
              <v-card outlined class="mt-4">
                <v-data-table
                  class="mt-4"
                  mobile-breakpoint="0"
                  :headers="errorHeaders"
                  :items="excelErrorStudents"
                  :footer-props="{
                    'items-per-page-text': 'Học sinh mỗi trang',
                    'items-per-page-all-text': 'Tất cả'
                  }"
                >
                  <template v-slot:[`footer.page-text`]="items">
                    {{ items.pageStart }} - {{ items.pageStop }} trên tổng
                    {{ items.itemsLength }}
                  </template>
                  <template v-slot:[`item.index`]="{ item }">
                    {{ excelErrorStudents.indexOf(item) + 1 }}
                  </template>
                </v-data-table>
              </v-card>
            </div>
            <div v-else>
              <div class="my-4">
                <span class="error--text">*</span
                ><b>Vui lòng kiểm tra lại thông tin học sinh và điểm và ấn [Thêm điểm] để tạo mới điểm số</b><br />
              </div>
              <v-card outlined>
                <v-data-table
                  class="mt-4"
                  mobile-breakpoint="0"
                  item-key="studentCode"
                  :headers="originHeaders"
                  :items="excelStudents"
                  :footer-props="{
                    'items-per-page-text': 'Học sinh mỗi trang',
                    'items-per-page-all-text': 'Tất cả'
                  }"
                  disable-sort
                >
                  <template v-slot:[`footer.page-text`]="items">
                    {{ items.pageStart }} - {{ items.pageStop }} trên
                    {{ items.itemsLength }}
                  </template>
                  <template v-slot:[`item.mark`]="{ item }">
                    <div v-if="$_get(filterParams, 'subject.markType') === 'mark'">
                      {{ item.mark }}
                    </div>
                    <div v-else>
                      <div v-if="item.mark === '1'">
                        Đạt
                      </div>
                      <div v-else-if="item.mark === '0'">
                        Chưa Đạt
                      </div>
                      <div v-else>
                        ---
                      </div>
                    </div>
                  </template>
                </v-data-table>
              </v-card>
            </div>
          </div>
          <div class="pa-5" style="height: 100%" v-else-if="step === 'result'">
            <div v-if="errorCreatedStudents.length">
              <div class="text-h6 mt-4 error--text">Lỗi tạo mới điểm</div>
              <div>
                Đã có {{ errorCreatedStudents.length }} học sinh gặp lỗi khi tạo mới.
                <span>
                  <b>
                    Vui lòng upload lại file excel với chỉ những HS tạo lỗi.
                  </b>
                </span>
              </div>
              <v-card outlined class="mt-4">
                <v-data-table
                  class="mt-4"
                  mobile-breakpoint="0"
                  :headers="errorCreatedHeaders"
                  :items="errorCreatedStudents"
                  :footer-props="{
                    'items-per-page-text': 'Học sinh mỗi trang',
                    'items-per-page-all-text': 'Tất cả'
                  }"
                  disable-sort
                >
                  <template v-slot:[`footer.page-text`]="items">
                    {{ items.pageStart }} - {{ items.pageStop }} trên tổng
                    {{ items.itemsLength }}
                  </template>
                  <template v-slot:[`item.index`]="{ item }">
                    {{ errorCreatedStudents.indexOf(item) + 1 }}
                  </template>
                  <template v-slot:[`item.dob`]="{ item }">
                    {{ item.dob | ddmmyyyy }}
                  </template>
                </v-data-table>
              </v-card>
            </div>
            <div v-else>Tạo mới thành công {{ excelStudents.length }} điểm học sinh.</div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions v-if="step === 'send'">
          <div class="d-flex justify-space-between align-center" style="width: 100%" v-if="excelStudents.length > 0">
            <v-btn color="gray" class="ma-2 px-8" :disabled="creating" @click="cancel" outlined>Hủy</v-btn>
            <v-btn color="primary" class="elevation-0 px-8" :loading="creating" @click="saveMarks">Thêm điểm</v-btn>
          </div>
          <div class="d-flex justify-space-between align-center" style="width: 100%" v-else>
            <v-btn color="gray" class="ma-2 px-8" @click="cancel" outlined>Hủy</v-btn>
          </div>
        </v-card-actions>
        <v-card-actions v-else-if="step === 'result'">
          <div class="d-flex justify-space-between align-center" style="width: 100%">
            <v-spacer></v-spacer>
            <v-btn color="primary" class="elevation-0 px-8" @click="cancel">Đóng</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import readXlsxFile from 'read-excel-file'
import { chunk, get } from 'lodash'
import { Class } from '../../plugins/api'
import { textHelpers } from '@/helpers/TextHelper.js'
import moment from 'moment'

const schema = {
  'Tên học sinh': {
    prop: 'studentName',
    type: String
  },
  'Mã số': {
    prop: 'studentCode',
    type: String
  },
  'Ngày sinh': {
    prop: 'dob',
    type: String
  },
  Lớp: {
    prop: 'studentClass',
    type: String
  },
  'Hệ số': {
    prop: 'factor',
    type: String
  },
  Điểm: {
    prop: 'mark',
    type: String
  }
}
export default {
  components: {},
  props: {
    state: Boolean,
    filterParams: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialog: false,
      creating: false,
      progress: 0,
      isSelecting: false,
      selectedFile: null,
      excelStudents: [],
      excelErrorStudents: [],
      errorCreatedStudents: [],
      step: 'import',
      studentObj: {},
      originHeaders: [
        {
          text: 'Tên học sinh',
          value: 'studentName',
        },
        {
          text: 'Mã số',
          value: 'studentCode',
        },
        {
          text: 'Ngày sinh',
          value: 'dob',
        },
        {
          text: 'Lớp',
          value: 'studentClass',
          width: 80
        },
        {
          text: 'Hệ số',
          value: 'factor',
        },
        {
          text: 'Điểm',
          value: 'mark',
        }
      ],
      errorHeaders: [
        {
          text: 'STT',
          value: 'index',
        },
        {
          text: 'Tên học sinh',
          value: 'studentName',
        },
        {
          text: 'Lớp',
          value: 'studentClass',
        },
        {
          text: 'Ngày sinh',
          value: 'dob',
        },
        {
          text: 'Điểm',
          value: 'mark',
        },
        {
          text: 'Lỗi',
          value: 'errorMsg',
        }
      ],
      errorCreatedHeaders: [
        {
          text: 'STT',
          value: 'index',
        },
        {
          text: 'Tên học sinh',
          value: 'studentName',
        },
        {
          text: 'Lớp',
          value: 'studentClass',
        },
        {
          text: 'Ngày sinh',
          value: 'dob',
        }
      ]
    }
  },
  computed: {
    ...mapGetters('auth', ['profile'])
  },
  methods: {
    ...mapActions('ClassMarkInput', ['createMark']),

    cancel() {
      this.dialog = false
      this.reset()
    },
    reset() {
      this.excelErrorStudents = []
      this.excelStudents = []
      this.selectedFile = null
      this.step = 'import'
    },
    cancelChooseFile() {
      this.step = 'import'
      this.selectedFile = null
      this.excelStudents = []
    },
    onExcelUpload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    async onFileChanged(e) {
      this.$loading.active = true
      this.selectedFile = e.target.files[0]
      let readFileResult
      try {
        readFileResult = await readXlsxFile(this.selectedFile, {
          schema
        })
      } catch (error) {
        this.$alert.error('File không có định dạng .xlsx hoặc có dữ liệu không hợp lệ (tham khảo mẫu file)')
        this.$loading.active = false
        return
      }
      if (readFileResult.errors.length !== 0) {
        const error = readFileResult.errors[0]
        this.$alert.error(`Lỗi Dòng ${error.row} - Cột ${error.column} - ${error.value}: ${error.error}`)
        this.$loading.active = false
        return
      } else {
        const results = readFileResult.rows
        const filteredResults = results.filter(
          s =>
            get(s, 'mark', '')
              .toString()
              .trim().length > 0
        )
        const isValid = await this.validateExcelData(filteredResults)
        if (isValid) {
          const students = results.map(student => {
            return { student: this.studentObj[student.studentCode], ...student }
          })

          this.excelStudents = students
            .map(s => {
              const mark = get(s, 'mark', '')
                .toString()
                .trim()
              if (mark) {
                s.mark = mark
                return s
              }
              return null
            })
            .filter(Boolean)
        }

        this.step = 'send'
      }

      this.$loading.active = false
    },
    async validateExcelData(students) {
      // fetch classes
      const currentClass = await Class.fetchOne(this.filterParams.class.id)
      const studentClassCodes = currentClass.students.map(s => s.code)

      const excelErrorStudents = []
      students.map(student => {
        let errorMsg = ''
        const studentName = student.studentName && textHelpers.removeSpaces(student.studentName)
        const isValidClass = student.studentClass && currentClass.title === student.studentClass
        const isValidDob = student.dob && moment(student.dob.trim(), 'DD/MM/YYYY', true).isValid()
        let mark = null
        if (student.mark && student.mark.toString().trim()) mark = +student.mark.toString().trim()

        if (!studentName) errorMsg = 'Tên không hợp lệ'
        if (!studentClassCodes.includes(student.studentCode)) {
          errorMsg += (errorMsg ? ', ' : '') + 'Mã HS không hợp lệ hoặc HS không thuộc lớp'
        }
        if (!isValidClass) errorMsg += (errorMsg ? ', ' : '') + 'Lớp không tồn tại'
        if (!isValidDob) errorMsg += (errorMsg ? ', ' : '') + 'Ngày sinh không hợp lệ'

        if (mark !== 0 && !mark) {
          errorMsg += (errorMsg ? ', ' : '') + 'Sai định dạng điểm'
        }

        if (this.filterParams.subject.markType === 'mark') {
          if (mark && (mark < 0 || mark > 10 || mark.toString().length !== student.mark.toString().length)) {
            errorMsg += (errorMsg ? ', ' : '') + 'Điểm phải từ 0 đến 10'
          }
        } else {
          if (mark !== 0 && mark !== 1) {
            errorMsg += (errorMsg ? ', ' : '') + 'Điểm đánh giá phải là 0 hoặc 1'
          }
        }

        if (errorMsg) {
          excelErrorStudents.push({
            ...student,
            errorMsg
          })
        }
      })

      this.excelErrorStudents = excelErrorStudents
      if (excelErrorStudents.length) return false

      currentClass.students.map(student => {
        const code = this.$options.filters.getStudentCode(student.code)
        this.studentObj[`${code}`] = student
      })
      return true
    },
    async saveMarks() {
      this.creating = true
      const groups = chunk(this.excelStudents, 3)
      let count = 1
      const length = groups.length
      const createdMarkIds = []
      for (let subMarkStudents of groups) {
        const promises = subMarkStudents.map(item => {
          let mark = +item.mark
          if (mark !== 0 && !mark) return null
          if (this.filterParams.subject.markType === 'mark') {
            if (mark < 0 || mark > 10) {
              return null
            }
          } else {
            if (mark !== 0 && mark !== 1) {
              return null
            }
          }

          const params = {
            student: item.student.id,
            value: mark,
            class: get(this.filterParams, 'class.id'),
            subject: get(this.filterParams, 'subject.id'),
            grade: get(this.filterParams, 'class.grade.id', null) || get(this.filterParams, 'class.grade'),
            semester: get(this.filterParams, 'semester.id'),
            factor: get(this.filterParams, 'factor.id'),
            date: get(this.filterParams, 'date'),
            staff: this.profile.id,
            teacher: this.profile.id
          }
          return this.createMark(params)
        })

        const createdMarks = await Promise.all(promises)
        createdMarkIds.push(...createdMarks.map(m => m.id))
        this.$alert.success('Lưu điểm thành công')

        this.progress = (count / length) * 100
        count++
      }

      this.creating = false
      this.step = 'result'
      this.$emit('done', createdMarkIds)
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>

<style scoped>
.send-sms-container td:nth-child(1) {
  font-weight: bold;
  text-align: end;
  vertical-align: top;
}
.send-sms-container td:nth-child(2) {
  padding-left: 50px;
}
tr.spaceUnder > td {
  padding-bottom: 30px;
}
</style>
